import HashratesChart from './HashratesChart';

export default HashratesChart;
